document.addEventListener("DOMContentLoaded", function () {
  if (typeof LeaderLine === "undefined") {
    return;
  }

  // Wait for layout to settle before drawing lines
  setTimeout(() => {
    const groups = document.querySelectorAll(".decision-tree [data-group]");
    groups.forEach((group) => {
      const questions = group.querySelectorAll(".decision-tree__question-card");
      const recommendation = group.querySelector("[data-recommendation]");
      if (!recommendation) {
        return;
      }

      questions.forEach((question) => {
        // eslint-disable-next-line no-undef, no-new
        new LeaderLine(question, recommendation, {
          startSocket: "right",
          endSocket: "left",
          color: "#7660db",
          size: 2,
          startPlug: "none",
          endPlug: "arrow",
          startPlugSize: 0,
          endPlugSize: 0,
        });
      });
    });
  }, 1000);
});
